import React from 'react';
import { Icon } from 'ui';
import { Text, TEXT_VARIANTS } from 'ui/Typography';

export default class Criterion extends React.Component {
  render() {
    const { criterion } = this.props;

    return (
      <div className="QuestionPrompt-criterion d-f ai-fs">
        <div className="CircleNumber CircleNumber--checkMark mr-8 bg-gray-darkest mt-6 d-f ai-c jc-c">
          <Icon name="check" className="c-white is-10 fz-10 mt-2" />
        </div>
        <div>
          <Text variant={TEXT_VARIANTS.BODY_BOLD}>{criterion.name}</Text>
          <Text variant={TEXT_VARIANTS.BODY_LIGHT}>
            {' - '}
            {criterion.description || (
              <em>{t('feedback_criteria.criterion.no_description')}</em>
            )}
          </Text>
        </div>
      </div>
    );
  }
}
